"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalLayoutRenderer = exports.HORIZONTAL_LAYOUT_FORM_TEST_ID = void 0;
exports.HorizontalLayout = HorizontalLayout;
const jsx_runtime_1 = require("react/jsx-runtime");
const lodash_isempty_1 = __importDefault(require("lodash.isempty"));
const LayoutRenderer_1 = require("./LayoutRenderer");
const antd_1 = require("antd");
const react_1 = require("@jsonforms/react");
exports.HORIZONTAL_LAYOUT_FORM_TEST_ID = "horizontal-layout-form";
function HorizontalLayout({ uischema, schema, path, enabled, visible, renderers, cells, }) {
    const horizontalLayout = uischema;
    const groupLayout = uischema;
    const childProps = {
        elements: horizontalLayout.elements,
        schema,
        path,
        enabled,
        visible,
    };
    const form = antd_1.Form.useFormInstance();
    return ((0, jsx_runtime_1.jsxs)(antd_1.Form, { "data-testid": exports.HORIZONTAL_LAYOUT_FORM_TEST_ID, component: form ? false : "form", form: form, children: [!(0, lodash_isempty_1.default)(groupLayout.label) && groupLayout.label, (0, jsx_runtime_1.jsx)(antd_1.Row, { justify: "space-between", gutter: 12, align: "middle", children: (0, jsx_runtime_1.jsx)(LayoutRenderer_1.AntDLayout, { ...childProps, direction: "row", renderers: renderers, cells: cells }) })] }));
}
exports.HorizontalLayoutRenderer = (0, react_1.withJsonFormsLayoutProps)(HorizontalLayout);
